import { Controller } from '@hotwired/stimulus';
import axios from "axios";
import {getMeta} from "../helpers";
import {load} from "recaptcha-v3";

export default class extends Controller {

  static targets = ['verificationResponse'];

  async connect() {
    this.currentTimeout = null;
    this.formController = Stimulus.getControllerForElementAndIdentifier(this.element, 'axios-form');
    this.contractModal = document.getElementById('e-contract');
    this.privacyPolicyModal = document.getElementById('privacy-policy');
    this.inputFields = this.element.querySelectorAll('input:is([type="text"], [type="number"]):not(.d-none):not([name="code"]):not([name="client_email"]):not([name="client_password"])');

    const siteKey = this.element.hasAttribute('data-site-key') ? this.element.getAttribute('data-site-key') : undefined;
    const recaptcha = siteKey ? await load(siteKey) : undefined;

    this.inputFields.forEach(input => {
      input.addEventListener('input', this.checkInputs.bind(this));
    });

    this.cashDiscount = this.element.querySelector('#cashDiscount');
    this.debitDiscount = this.element.querySelector('#debitDiscount');

    this.formWarning = this.element.querySelector('#formWarning');

    this.ageWarningMessage = this.formWarning.getAttribute("data-age-warning");

    this.codeSubmitButton = this.element.querySelector('#codeSubmitButton');

    this.verificationCodeSubmitButton = this.element.querySelector('#verificationCodeSubmitButton');

    this.currentLanguageCode = getMeta('wp-language').split('-')[0];

    this.inputs = {
      type: this.element.querySelector('input[name="type"]'),
      debitID: this.element.querySelector('input[name="debit_id"]'),
      membershipID: this.element.querySelector('input[name="membership_id"]'),
      itemID: this.element.querySelector('input[name="item_id"]'),
      clientBirthday: this.element.querySelector('input[name="birthday"]'),
      underageClient: this.element.querySelector('input[name="underage_client"]'),
      existingClient: this.element.querySelector('input[name="existing_client"]'),
      appliedDiscountCode: this.element.querySelector('input[name="applied_discount_code"]'),
      appliedCouponCode: this.element.querySelector('input[name="applied_coupon_code"]'),
      appliedAdditionalServicesCode: this.element.querySelector('input[name="applied_additional_services_code"]'),
      code: this.element.querySelector('input[name="code"]'),
      membershipPostId: this.element.querySelector('input[name="membership_post_id"]'),
      acceptContract: this.element.querySelector('input[name="consents[e_contract]"]'),
      privacyPolicyConsent: this.element.querySelector('input[name="consents[personal_data]"]'),
      phone: this.element.querySelector('input[data-name="phone"]'),
    };

    this.type = this.inputs.type ? this.inputs.type.value : null;

    if (this.type && this.type === 'debit') {
      this.inputFields = this.element.querySelectorAll('input:is([type="text"], [type="number"]):not(.d-none):not([name="code"]):not([name="client_email"]):not([name="client_password"]):not([name="verification_code"])');
    } else {
      this.inputFields = this.element.querySelectorAll('input:is([type="text"], [type="number"]):not(.d-none):not([name="code"]):not([name="client_email"]):not([name="client_password"]):not([name="verification_code"]):not([name="account"])');
    }

    this.inputFields.forEach(input => {
      input.addEventListener('input', this.checkInputs.bind(this));
    });

    //Check if client is underage and show form accordingly
    if (this.inputs.clientBirthday) {
      this.inputs.clientBirthday.addEventListener('input', (e) => {
        const age = this.getAge(e.target.value);
        if (age < 18) {
          this.inputs.underageClient.value = '1';
          this.payerFormVisibility(true);
        } else {
          this.inputs.underageClient.value = '0';
          this.payerFormVisibility(false);
        }
        this.checkInputs();
      })
    }

    //Wait for discount input and validate it
    if (this.inputs.code && this.codeSubmitButton) {
      this.inputs.code.addEventListener('input', (e) => {
        if (!e.target.value) {
          this.removeDiscountError();
          this.cashDiscount.innerHTML = '';
          this.debitDiscount.innerHTML = '';
          this.inputs.appliedDiscountCode.value = '';
          this.inputs.appliedCouponCode.value = '';
        }
      });

      this.codeSubmitButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.inputs.code.value && this.inputs.appliedCouponCode.value !== this.inputs.code.value && this.inputs.appliedDiscountCode.value !== this.inputs.code.value) {
          this.validateDiscount(this.inputs.code);
        }
      });
    }

    if (this.inputs.phone && this.verificationCodeSubmitButton) {
      this.verificationCodeSubmitButton.addEventListener('click', async (e) => {
        e.preventDefault();
        const token = recaptcha ? await recaptcha.execute('submit') : undefined;
        this.sendVerificationCode(token);
      });
    }

    if (this.inputs.acceptContract && this.contractModal) {
      this.modalAccept = this.contractModal.querySelector('.modal-accept');
      this.modalReplacement = this.contractModal.querySelector('.replace-content');
      this.modalLoader = this.contractModal.querySelector('.contract-loader');

      this.acceptContractLabel = this.element.querySelector('.consent__e_contract .label-text');

      if (this.acceptContractLabel) {
        this.acceptContractLabel.addEventListener('click', (event) => this.showEContractAcceptModal(event, true));
      }

      this.modalAccept.addEventListener('click', () => {
        if (!this.inputs.acceptContract.checked) {
          this.inputs.acceptContract.checked = true;
        }
        this.modalController = Stimulus.getControllerForElementAndIdentifier(this.contractModal, 'modal');
        this.modalController.hideModal();
      })
    }

    if (this.inputs.privacyPolicyConsent && this.privacyPolicyModal) {
      this.modalAccept = this.privacyPolicyModal.querySelector('.modal-accept');

      this.privacyPolicyConsentLabel = this.element.querySelector('.consent__personal_data .label-text');

      if (this.privacyPolicyConsentLabel) {
        this.privacyPolicyConsentLabel.addEventListener('click', (event) => this.showPrivacyPolicyModal(event, true));
      }

      this.modalAccept.addEventListener('click', () => {
        if (!this.inputs.privacyPolicyConsent.checked) {
          this.inputs.privacyPolicyConsent.checked = true;
        }
        this.modalController = Stimulus.getControllerForElementAndIdentifier(this.privacyPolicyModal, 'modal');
        this.modalController.hideModal();
      })
    }

    this.toggleNewClient();
    this.checkInputs();
  }

  changePaymentType(event) {
    this.resetDiscountCode();
    if (event.target.value === 'debit') {
      this.type = 'debit';
      this.element.classList.add('debit-checkout')
    } else {
      this.type = 'cash';
      this.element.classList.remove('debit-checkout');
    }
  }

  changeAmount() {
    const amountElement = this.element.querySelector('.coupon-amount-input');
    const priceElement = this.element.querySelector('.item-price');

    if (amountElement && priceElement) {
      const price = parseFloat(amountElement.dataset.originalPrice);
      let amount = parseInt(amountElement.value);

      amount = amount > 0 ? amount : 1;
      amount = amount < 99 ? amount : 99;
      priceElement.innerHTML = (Math.round((amount * price) * 100) / 100).toFixed(2) + ' €';
      amountElement.value = amount + '';
    }
  }

  removeDiscountError() {
    const wrap = this.inputs.code.parentNode.parentNode;
    this.inputs.code.classList.remove('invalid');
    const inputError = wrap.querySelector('.input-error');
    if (inputError) {
      inputError.remove();
    }
  }

  resetDiscountCode() {
    this.removeDiscountError();
    this.inputs.code.value = '';
    this.inputs.appliedDiscountCode.value = '';
  }

  validateDiscount(input) {
    if (this.codeSubmitButton.classList.contains('loading')) {
      return;
    }

    this.codeSubmitButton.classList.add('loading');

    this.removeDiscountError();
    this.inputs.appliedDiscountCode.value = '';
    this.inputs.appliedCouponCode.value = '';
    this.inputs.code.disabled = true;
    const url = '/wp-json/api/validate-discount-coupon?rest_language=' + this.currentLanguageCode;

    let formData = new FormData;
    formData.append('code', input.value);
    formData.append('type', this.type);
    formData.append('debit_id', this.inputs.debitID.value);
    formData.append('membership_id', this.inputs.membershipID.value);
    formData.append('membership_post_id', this.inputs.membershipPostId.value);

    this.formController.removeFormNotes();

    this.cashDiscount.innerHTML = '';
    this.debitDiscount.innerHTML = '';

    axios.post(url, formData).then((response)=>{
      this.inputs.code.disabled = false;
      this.codeSubmitButton.classList.remove('loading');

      response = response.data.data;

      if (response && response.errors && Object.keys(response.errors).length) {
        this.formController.setupFormErrors(response.errors);

      } else if (response && response.general_error) {
        this.formController.setupFormGeneralError(response);
        console.log(response.general_error)

      } else if (response && response.general_success) {
        this.formController.setupFormGeneralSuccess(response);

        if (input.value) {
          if (response.code_type === 'coupon') {
            this.inputs.appliedCouponCode.value = input.value;
          }
          if (response.code_type === 'discount') {
            this.inputs.appliedDiscountCode.value = input.value;
          }
          if (response.code_type === 'additional-services-code') {
            this.inputs.appliedAdditionalServicesCode.value = input.value;
          }

          if (response.type === 'cash') {
            this.cashDiscount.innerHTML = `<span class="text-secondary">- ${response.off_total}</span> = ${response.total}`
          }

          if (response.type === 'debit') {
            this.debitDiscount.innerHTML = `<span class="text-secondary">- ${response.off_total}</span> = ${response.total}`
          }

        }
      } else if (response && response.redirect) {
        window.location.href = response.redirect;

      } else if (response && response.reload) {
        window.location.reload();

      } else {
        if (!response || !response.action) {
          this.formController.setupFormUnexpectedError();
        }
      }
    })
  }

  sendVerificationCode(token, isRetry = false) {
    if (this.verificationCodeSubmitButton.classList.contains('loading')) {
      return;
    }

    this.verificationCodeSubmitButton.classList.add('loading');

    this.verificationCodeSubmitButton.disabled = true;
    this.verificationCodeSubmitButton.classList.add('disabled');

    const disableTimeout = setTimeout(() => {
        this.verificationCodeSubmitButton.disabled = false;
        this.verificationCodeSubmitButton.classList.remove('disabled');
    }, 60000);

    const url = '/wp-json/api/send-verification-code?rest_language=' + this.currentLanguageCode;

    let formData = new FormData;
    formData.append('phone', this.element.querySelector('input[name="phone"]').value);
    formData.append('personal_code', this.element.querySelector('input[name="personal_code"]').value);
    formData.append('membership_post_id', this.element.querySelector('input[name="membership_post_id"]').value);
    formData.append('is_retry', isRetry);

    if (token) {
      formData.append('token', token);
    }

    this.formController.removeFormNotes();

    axios.post(url, formData).then((response)=>{
      this.verificationCodeSubmitButton.classList.remove('loading');

      if (this.hasVerificationResponseTarget) {
        this.verificationResponseTarget.innerHTML = '';
      }

      const responseData = response.data.data;

      if (responseData.action_data.messageID) {
        this.verificationCodeSubmitButton.classList.add('loading');
        this.pollPhoneNumberStatus(responseData.action_data.messageID, formData);

        if (this.hasVerificationResponseTarget) {
          this.verificationResponseTarget.innerHTML =
              `<span class="text-success" data-checkout-target="verificationResponse">${responseData.action_data.text}</span>`
        }

      } else {
        this.handleFormResponse(responseData);
      }

      if (!responseData.success) {
        clearTimeout(disableTimeout);
        this.verificationCodeSubmitButton.disabled = false;
        this.verificationCodeSubmitButton.classList.remove('disabled');
        this.handleFormResponse(responseData);
      }
    }).catch((error)=>{
      this.verificationCodeSubmitButton.classList.remove('loading');
      const response = error.response.data.data;

      if (response && response.errors && Object.keys(response.errors).length) {
        this.formController.setupFormErrors(response.errors);
      }

      clearTimeout(disableTimeout);

      this.verificationCodeSubmitButton.disabled = false;
      this.verificationCodeSubmitButton.classList.remove('disabled');
    });
  }

  handleFormResponse(response) {
    if (response && response.general_error) {
      this.formController.setupFormGeneralError(response);

    } else if (response && response.general_success) {
      this.formController.setupFormGeneralSuccess(response);
    } else if (response && response.action && response.action === 'show_popup') {
      if (response.action_data) {
        const popup = document.getElementById('global-popup');

        if (popup) {
          const popupController = Stimulus.getControllerForElementAndIdentifier(popup, 'modal');

          if (popupController) {
            const content = popup.querySelector('.modal-inner');
            content.innerHTML = response.action_data;
            popupController.showModal();
          }
        }
      }
    } else if (response && response.redirect) {
      window.location.href = response.redirect;

    } else if (response && response.reload) {
      window.location.reload();

    } else {
      if (!response || !response.action) {
        this.formController.setupFormUnexpectedError();
      }
    }
  }

  async showEContractAcceptModal(event, force = false) {
    if (!this.inputs.acceptContract.disabled && (this.inputs.acceptContract.checked || force)) {
      event.preventDefault();
      this.modalController = Stimulus.getControllerForElementAndIdentifier(this.contractModal, 'modal');
      this.modalLoader.classList.remove('d-none');
      this.modalReplacement.innerHTML = '';
      this.modalController.showModal();

      const queryString = new URLSearchParams(new FormData(this.element)).toString();

      let response;

      const urlDebit = '/wp-json/api/debit-filled-pdf-template?rest_language=' + this.currentLanguageCode + '&' + queryString;
      const urlCash = '/wp-json/api/cash-pdf-template?rest_language=' + this.currentLanguageCode + '&' + queryString;

      const type = this.element.querySelector('input[name="type"]')

      try {
        if (type.value.toLowerCase() === 'cash') {
          response = await axios.get(urlCash);
        } else {
          response = await axios.get(urlDebit);
        }
        response = response.data.data;
      } catch (error) {
        response = error.response.data.data;
      }

      this.modalLoader.classList.add('d-none');

      if (response.contract) {
        this.modalReplacement.innerHTML = '<iframe></iframe>';
        // this.modalReplacement.innerHTML = '<iframe src="' + 'data:text/html,' + encodeURIComponent(response.contract) + '"></iframe>';

        //setTimeout needed for Firefox to display content
        setTimeout(()=>{
          this.modalReplacement.firstElementChild.contentWindow.document.body.innerHTML = response.contract;
          this.modalReplacement.firstElementChild.height = this.modalReplacement.firstElementChild.contentWindow.document.body.scrollHeight + 'px';
        }, 0)

        // this.modalReplacement.innerHTML = response.contract;
      } else {
        const messageNode = document.createElement('span');
        messageNode.classList.add('general-error');
        messageNode.innerHTML = document.querySelector('meta[name="global_axios_validator_error"]').content;
        this.modalReplacement.innerHTML = messageNode;
      }
    } else {
      this.modalReplacement.innerHTML = '';
    }
  }

  async showPrivacyPolicyModal(event, force = false) {
    if (!this.inputs.privacyPolicyConsent.disabled && (this.inputs.privacyPolicyConsent.checked || force)) {
      event.preventDefault();
      this.modalController = Stimulus.getControllerForElementAndIdentifier(this.privacyPolicyModal, 'modal');
      this.modalController.showModal();
    }
  }

  toggleNewClient(event) {
    let newClient = false;
    if (event) {
      newClient = event.currentTarget.querySelector('[name="new_client"]').value === '1';
    } else {
      newClient = this.inputs.existingClient.value === '0';
    }

    if (newClient) {
      this.element.classList.add('new-client-form');
      if (this.inputs.underageClient.value === '1') {
        this.payerFormVisibility(true);
      }
      this.element.querySelectorAll('.existing-client-element').forEach((element)=>{
        element.style.display = 'none';
      });
      this.element.querySelectorAll('.new-client-element').forEach((element)=>{
        element.style.display = 'block';
      });
    } else {
      this.element.classList.remove('new-client-form');
      this.payerFormVisibility(false);
      this.element.querySelectorAll('.existing-client-element').forEach((element)=>{
        element.style.display = 'block';
      });
      this.element.querySelectorAll('.new-client-element').forEach((element)=>{
        element.style.display = 'none';
      });
    }
  }

  payerFormVisibility(visible) {
    if (visible) {
      this.element.classList.add('payer-form');
      this.formWarning.classList.remove('d-none');
      this.formWarning.innerHTML = this.ageWarningMessage;
    } else {
      this.element.classList.remove('payer-form');
      this.formWarning.classList.add('d-none');
      this.formWarning.innerHTML = '';
    }
  }

  getAge(birthDate) {
    return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e+10)
  }

  // Function to check if all visible non-hidden input fields are filled
  checkInputs() {
    const underage = this.inputs.underageClient.value === '1';
    const isTakeover = this.element.closest('#membership-takeover-form') !== null;

    if (!isTakeover) {
      const allVisibleNonHiddenInputsFilled = Array.from(this.inputFields).every(input => {
        if (underage) {
          return input.value.trim() !== '';
        } else {
          return input.classList.contains('payer') || input.value.trim() !== '';
        }
      });

      if (allVisibleNonHiddenInputsFilled) {
        this.inputs.acceptContract.removeAttribute('disabled');
        this.inputs.acceptContract.parentNode.classList.remove('disabled');
      } else {
        this.inputs.acceptContract.setAttribute('disabled', 'disabled');
        this.inputs.acceptContract.parentNode.classList.add('disabled');
      }
    }
  }

  pollPhoneNumberStatus(messageId, originalFormData, attempt = 0) {
    const pollInterval = 5000;
    const maxAttempts = 10;

    let formData = new FormData();
    formData.append('message_id', messageId);
    formData.append('phone', originalFormData.get('phone'));

    axios.post('/wp-json/api/phone-checks/get-message', formData)
        .then(async response => {
          const responseData = response.data.data;

          if (responseData.success && responseData.action_data.status === 'DELIVERED_TO_HANDSET') {
            const siteKey = this.element.hasAttribute('data-site-key') ? this.element.getAttribute('data-site-key') : undefined;
            const recaptcha = siteKey ? await load(siteKey) : undefined;
            const token = recaptcha ? await recaptcha.execute('submit') : undefined;
            this.verificationCodeSubmitButton.classList.remove('loading');
            this.sendVerificationCode(token, true);
          } else if (responseData.success && responseData.action_data.status) {
            if (this.hasVerificationResponseTarget) {
              this.verificationResponseTarget.innerHTML =
                  `<span class="text-error" data-checkout-target="verificationResponse">${responseData.action_data.text}</span>`
            }
            this.verificationCodeSubmitButton.classList.remove('loading');
          } else if (attempt < maxAttempts) {
            setTimeout(() => {
              this.pollPhoneNumberStatus(messageId, originalFormData, attempt + 1);
            }, pollInterval);
          } else {
            if (this.hasVerificationResponseTarget) {
              this.verificationResponseTarget.innerHTML =
                  `<span class="text-error" data-checkout-target="verificationResponse">${responseData.action_data.error_message}</span>`
              this.verificationCodeSubmitButton.classList.remove('loading');
            }
          }
        })
  }
}
